export const getStatusIndicatorType = (status) => {
    const statusMap = {
        Hold: 'pending',
        Active: 'success',
        Canceled: 'error',
        Tentative: 'warning',
    };
    return statusMap[status] || 'info';
};
